/* ============================================================================
   APEIROS SCENTS — Brand interaction layer  (vanilla JS, no dependencies)
   • scroll reveals (.ap-reveal, [data-ap-stagger]) + [data-ap-count] count-up
   • product-card hover lift (article.ap-card)
   • foil shimmer / ghost hover on [data-foil] / [data-ghost] (delegated)
   • sticky header state on <body>
   Interactive page widgets (note walk, layering bench, quiz) ship in their
   own section assets; this file only owns the shared house behaviors.
   ========================================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------- reveals */
  function countUp(el) {
    if (el.dataset.apCounted) return;
    el.dataset.apCounted = '1';
    var m = el.textContent.trim().match(/^(\D*)(\d+)(?:[–-](\d+))?(\D*)$/);
    if (!m) return;
    var pre = m[1], lo = m[3] ? parseInt(m[2], 10) : null, hi = parseInt(m[3] || m[2], 10), post = m[4];
    if (reduce) { return; }
    var t0 = performance.now();
    (function tick(now) {
      var p = Math.min(1, (now - t0) / 1500), e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + (lo !== null ? Math.round(lo * e) + '–' + Math.round(hi * e) : Math.round(hi * e)) + post;
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }

  function initReveals(root) {
    root = root || document;
    var items = [].slice.call(root.querySelectorAll('.ap-reveal, [data-ap-stagger]'));
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-in');
        el.querySelectorAll('[data-ap-count]').forEach(countUp);
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        en.target.querySelectorAll('[data-ap-count]').forEach(countUp);
        io.unobserve(en.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el) { io.observe(el); });
    // failsafe: never leave content hidden
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 4500);
  }

  /* ------------------------------------------------- product-card lift */
  function initCardLift(root) {
    (root || document).querySelectorAll('article.ap-card').forEach(function (card) {
      if (card.dataset.apLift) return;
      card.dataset.apLift = '1';
      var img = card.querySelector('img');
      card.addEventListener('mouseenter', function () {
        card.style.transform = 'translateY(-6px)';
        if (img) { img.style.transform = 'translateY(-14px) scale(1.045)'; img.style.filter = 'drop-shadow(0 42px 44px rgba(0,0,0,.8))'; }
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
        if (img) { img.style.transform = ''; img.style.filter = 'drop-shadow(0 26px 34px rgba(0,0,0,.7))'; }
      });
    });
  }

  /* --------------------------------------------- foil / ghost hover (deleg) */
  function initFoil() {
    if (document.body.dataset.apFoil) return;
    document.body.dataset.apFoil = '1';
    document.body.addEventListener('mouseover', function (e) {
      var t = e.target.closest && e.target.closest('[data-foil]');
      if (!t || (e.relatedTarget && t.contains(e.relatedTarget))) return;
      t.style.animation = 'apFoil 1.5s cubic-bezier(.3,0,.3,1)';
    });
    document.body.addEventListener('animationend', function (e) {
      var t = e.target;
      if (t.hasAttribute && t.hasAttribute('data-foil')) t.style.animation = '';
    }, true);
  }

  /* ------------------------------------------------------- sticky header */
  function initHeaderState() {
    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      document.body.classList.toggle('apeiros-scrolled', y > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function boot(root) {
    initReveals(root);
    initCardLift(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
    initFoil();
    initHeaderState();
  });

  // Re-run for Shopify theme-editor section loads
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  // expose for section scripts that build DOM dynamically
  window.Apeiros = { reveals: initReveals, cardLift: initCardLift };
})();
